// Lightweight visit tracker — POSTs /api/track on every route change.
// A session_id cookie identifies unique visitors for 30 days without needing login.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const SESSION_COOKIE = "flixvps_visit";
const COOKIE_DAYS = 30;

function getOrCreateSessionId() {
  const match = document.cookie.match(new RegExp(`${SESSION_COOKIE}=([^;]+)`));
  if (match) return decodeURIComponent(match[1]);
  const id = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/-/g, "");
  const exp = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
  document.cookie = `${SESSION_COOKIE}=${encodeURIComponent(id)}; expires=${exp}; path=/; SameSite=Lax`;
  return id;
}

export default function useVisitTracker() {
  const location = useLocation();
  useEffect(() => {
    // Ignore admin pages so we don't skew the numbers with our own navigation
    if (location.pathname.startsWith("/admin")) return;
    const session_id = getOrCreateSessionId();
    const payload = {
      path: location.pathname + (location.search || ""),
      referrer: document.referrer || "",
      session_id,
      screen: `${window.screen?.width || 0}x${window.screen?.height || 0}`,
    };
    // Fire-and-forget; never blocks navigation
    api.post("/track", payload).catch(() => {});
  }, [location.pathname, location.search]);
}
